<template>
  <div id="home">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <div>
            <span class="locations-title">
              IMEJ Tech.com
              <a href="#/" class="logo-link">
                <img src="../assets/logo.svg" id="logo" alt="logo" />
                <div></div>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="centered-box locations-white locations-generic">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div>
              <div class="font-weight-bold mt-1">
                <div class="card">
                  <img
                    src="../assets/ai-pic4.png"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <h5 class="card-title">Get Your Website Rolling with IMEJ Tech.com</h5>
                    <a
                      href="./components/Contact#/Contact"
                      class="btn btn-primary"
                      >Contact</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div>
              <div class="font-weight-bold mt-1">
                <div class="card">
                  <img
                    src="../assets/ai-pic3.png"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <h5 class="card-title">
                      We Are Here For Your Website Wants and Needs
                    </h5>
                    <a
                      href="./components/Contact#/Contact"
                      class="btn btn-primary"
                      >Ask Us</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div>
              <div class="font-weight-bold mt-1">
                <div class="card">
                  <img
                    src="../assets/ai-pic5.png"
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <h5 class="card-title">
                      We Build from Scratch, Squarespace, and Wordpress.
                    </h5>
                    <a
                      href="./components/Contact#/Contact"
                      class="btn btn-primary"
                      >Our Technology</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col">
            <div class="font-weight-bold mt-1">
              <div class="card">
                <img
                  src="../assets/screen-3.png"
                  class="card-img-top"
                  alt="..."
                />
                <div class="card-body">
                  <h5 class="card-title">Make Your Website Your Vision @ IMEJ Tech.com</h5>
                  <a
                    href="./components/Contact#/Contact"
                    class="btn btn-primary"
                    >Questions
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="card-header"></div>
        <div class="card-body">
          <h5 class="card-title">
            <div>
              <span class="locations-title">
                IMEJ Tech
                <a href="#/" class="logo-link">
                  <img src="../assets/logo.svg" id="logo" alt="logo" />
                  <div>Website Development &amp; Design</div>
                  <div></div>
                </a>
              </span>
            </div>
          </h5>
          <hr />
          We create the best websites possible. We build from Scratch,
          Squarespace, and Wordpress. Let's make your website your vision. get
          your website rolling.
          <hr />
          <br />
          <a href="./components/Contact#/Contact" class="btn btn-primary"
            >Contact Us</a
          ><br /><br />
          Please Contact us for a Free Consultation.
          <br />
        </div>
        <div class="card-header"></div>
        <div class="card-body">
          <blockquote class="blockquote mb-0">
            <p>“It's not a faith in technology. It's faith in people.”</p>
            <footer class="blockquote-footer">
              Steve Jobs, Co-founder of Apple.
            </footer>
            <div class="card-footer"></div>
          </blockquote>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: black;
}
.a-hover {
  color: #e3e6e6 !important;
}
.locations-title {
  text-transform: inherit;
}
hr {
  background-color: black !important;
}
.card {
  max-width: 330px;
  width: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
}
.card-img-top {
  height: 220px;
  object-fit: cover;
}
.card-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}
.card-header {
  background-color: #0d0004;
  background-image: url("https://www.transparenttextures.com/patterns/black-orchid.png");
}
.card-footer {
  background-color: #0d0004;
  background-image: url("https://www.transparenttextures.com/patterns/black-orchid.png");
}
#home {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/screen-5.png");
  background-size: cover;
  background-position: center;
  animation: backgroundMove 200s ease-in-out infinite;
}
.page {
  background-image: url("../assets/blue1.jpg");
  flex-direction: column;
}
a.btn:hover {
  color: rgb(192, 80, 77) !important;
}
ul {
  list-style-type: none;
}
a.btn-primary {
  margin-bottom: 0px;
  text-align: center;
  display: inline-block;
}
.locations-white {
  margin: 20px 0px;
}
p {
  font-weight: 100;
}
#logo {
  height: 20px;
  padding-left: 0px;
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
